import { render, staticRenderFns } from "./nav-top-stu.vue?vue&type=template&id=c572b3a2&scoped=true"
import script from "./nav-top-stu.vue?vue&type=script&lang=js"
export * from "./nav-top-stu.vue?vue&type=script&lang=js"
import style0 from "./nav-top-stu.vue?vue&type=style&index=0&id=c572b3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c572b3a2",
  null
  
)

export default component.exports